const forecastDateWidget = {

  async init($, fetchForecast) {
    this.$ = $;
    this.fetchForecast = fetchForecast || (() => this.fetchForecastHashByIdAsync());
    this.initParams();
    this.dayjsLocale = this.locale.split('-')[0].toLowerCase();
    dayjs.locale(this.dayjsLocale);
    this.initDatePicker();
    this.initEvents();
    await this.loadForecast();
  },

  async loadForecast() {
    this.handleShowForecastButton(false);
    this.setStatus('');

    try {
      const forecast = await this.fetchForecast();
      const dates = Object.keys(forecast || {})
        .filter(key => /^\d{4}-\d{2}-\d{2}T12:00:00Z$/.test(key))
        .map(key => key.slice(0, 10))
        .sort();
      const currentPrice = Number(forecast?.currentPrice);

      if (!dates.length || !Number.isFinite(currentPrice)) {
        throw new Error('Forecast response has no dates or current price');
      }

      this.availableDates = new Set(dates);
      this.updateDateRange(dates);
      this.forecast = forecast;
      this.currentPrice = currentPrice;
      this.handleShowForecastButton(true);
    } catch (error) {
      console.error('Failed to load forecast:', error);
      this.handleShowForecastButton(true);
      this.setStatus(this.errorMessage);
    }
  },

  setStatus(message) {
    const status = this.$('#forecast-widget-status');
    status.text(message);
    status.prop('hidden', !message);
  },

  dateFromKey(key) {
    const [year, month, day] = key.split('-').map(Number);
    return new Date(year, month - 1, day);
  },

  updateDateRange(dates) {
    const tomorrow = new Date(this.dateNow.getFullYear(), this.dateNow.getMonth(), this.dateNow.getDate() + 1);
    const firstFutureDate = dates.find(key => this.dateFromKey(key) >= tomorrow);
    if (!firstFutureDate) {
      throw new Error('Forecast response has no future dates');
    }

    this.pickerControl.datepicker('option', {
      minDate: this.dateFromKey(firstFutureDate),
      maxDate: this.dateFromKey(dates[dates.length - 1]),
      beforeShowDay: date => [this.availableDates.has(dayjs(date).format('YYYY-MM-DD'))],
    });
    this.pickerControl.datepicker('setDate', this.dateFromKey(firstFutureDate));
  },

  handleShowForecastButton(show) {
    const showForecastButton = this.$('#show-forecast-button');

    if (!show) {     
      this.showForecastButtonLabel ||= showForecastButton.html();
      showForecastButton.html('...');
      showForecastButton.attr('disabled', true);
    }
    else{
      showForecastButton.attr('disabled', false);
      showForecastButton.html(this.showForecastButtonLabel);
    }
  },

  initParams() {
    this.dateNow = new Date();
    const dataset = this.$('.forecast-date-widget-wrapper')[0].dataset;
    this.currency = dataset.currency;
    this.dateFormat = dataset.dateFormat;
    this.locale = dataset.locale;
    this.coinId = dataset.coinId;
    this.errorMessage = dataset.loadError;
    this.dateErrorMessage = dataset.dateError;
    this.pickerControl = this.$('#forecast-datepicker');
  },

  async fetchForecastHashByIdAsync() {
      let response = await fetch(ajaxurl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        body: new URLSearchParams({
          'action': 'fetchForecastHashById',
          'id': this.coinId
        })
      });

      if (!response.ok) {
        let error = await response.text();
        throw new Error('HTTP status ' + response.status + ': ' + error);
      }

      let result = await response.json();
      if (!result.success || !result.data) {
        throw new Error('Forecast response is invalid');
      }
      return result.data;
  },

  initDatePicker() {
    const queryDate = new Date();
    queryDate.setDate(queryDate.getDate() + 1);
    
    this.pickerControl.datepicker({
      dateFormat: this.dateFormat,
      nextText: '',
      prevText: '',
      minDate: 1,
      maxDate: null,
      showOtherMonths: true,
      selectOtherMonths: true
    });
    
    this.$('#ui-datepicker-div').css('display', 'none');

    this.pickerControl.datepicker('setDate', queryDate);
  },

  initEvents() {
    this.$('.forecast-date__icon').on('click', () => {
      this.pickerControl.datepicker('show');
    });

    this.$('.forecast-date-widget-btn button').on('click', (event) => {
      if (!this.forecast) {
        void this.loadForecast();
        return;
      }
      if (this.getAveragePriceByDate(this.getSelectedDate()) === undefined) {
        this.setStatus(this.dateErrorMessage);
        return;
      }

      this.setStatus('');
      const wrapper = this.$(event.currentTarget).closest(
        '.forecast-date-widget-wrapper'
      );
      if (!wrapper.hasClass('open')) {
        wrapper.addClass('open');
      }
      this.showForecast();
      this.$('.forecast-details').css('display', 'block');
    });
  },

  showForecast() {
    this.setCurrentPrice();
    this.setForecastPrice();
    this.setChangeRange();
  },

  beautifyDate(date) {
    return dayjs(date).locale(this.dayjsLocale).format('DD MMMM YYYY');
  },

  setCurrentPrice() {
    let basePrice = this.$('#forecastWidgetCurrentPrice');
    let basePriceDate = this.$('#forecastWidgetCurrentPriceDate span');
    basePrice.html(this.formatNumber(this.currentPrice));

    const beautifiedDate = this.beautifyDate(this.dateNow);
    basePriceDate.html(beautifiedDate);
  },

  setForecastPrice() {
    let basePrice = this.$('#forecastWidgetForecastPrice');
    let basePriceDate = this.$('#forecastWidgetForecastPriceDate span');
    const selectedDate = this.getSelectedDate();

    this.averagePrice = this.getAveragePriceByDate(selectedDate);

    basePrice.html(this.formatNumber(this.averagePrice));

    const beautifiedDate = this.beautifyDate(selectedDate);

    basePriceDate.html(beautifiedDate);
  },

  setChangeRange() {
    let changeValue = this.$('#forecastWidgetChangeValue');

    let diffPrice = this.calculateValueDiff();
    let diffPercent = this.calculaPercentDiff();
    let signAndStyle = this.getSignAndStyle(diffPrice);

    changeValue.html(
      `<span class='${signAndStyle[1]}'>${signAndStyle[0]}${this.formatNumber(
        diffPrice
      )} / ${signAndStyle[0]}${this.formatPercent(diffPercent)}%</span>`
    );
  },

  getSelectedDate() {
    return this.pickerControl.datepicker('getDate');
  },

  getAveragePriceByDate(date) {
    return this.forecast[dayjs(date).format('YYYY-MM-DD[T]12:00:00[Z]')];
  },

  calculateValueDiff() {
    return this.averagePrice - this.currentPrice;
  },

  calculaPercentDiff() {
    return (this.averagePrice / this.currentPrice - 1) * 100;
  },

  getSignAndStyle(value) {
    let sign = '';
    let style = 'red';

    if (value >= 0) {
      sign = '+';
      style = 'green';
    }

    return [sign, style];
  },

  formatNumber(value) {
    value = parseFloat(value);
    return new Intl.NumberFormat(this.locale, {
      style: 'currency',
      currency: this.currency,
      currencyDisplay: 'narrowSymbol',
      maximumFractionDigits: this.getFloatPoints(value),
    }).format(value);
  },

  formatPercent(value) {
    value = parseFloat(value);
    return new Intl.NumberFormat(this.locale, {
      maximumFractionDigits: this.getPercentsPoints(value),
    }).format(value);
  },

  getPercentsPoints(diffPercent) {
    let fixedDigitsPercent = 2;

    if (diffPercent >= 0.0 && diffPercent <= 1.0) {
      fixedDigitsPercent = 4;
    }

    return fixedDigitsPercent;
  },

  getFloatPoints(value) {
    value = Math.abs(value);

    if (value < 0.00000000005) {
      return 15;
    }

    if (value < 0.000000005) {
      return 13;
    }

    if (value < 0.0000005) {
      return 11;
    }

    if (value < 0.00005) {
      return 9;
    }

    if (value < 0.005) {
      return 7;
    }

    if (value < 0.05) {
      return 6;
    }

    if (value < 0.5) {
      return 5;
    }

    if (value < 1) {
      return 4;
    }

    if (value < 5) {
      return 3;
    }

    if (value > 100000) {
      return 0;
    }

    return 2;
  },
};

export default forecastDateWidget;
